function parseHotelItems(items) {
    return items.map(item => {
        item.ranges = item.ranges.map(range => {
            if (!range) {
                return range;
            }

            range = range.map(day => {
                day.from = new Date(day.from * 1000);
                day.to = new Date(day.to * 1000);

                day.variations = day.variations.map(variation => {
                    variation.date = new Date(variation.date * 1000);

                    return variation;
                });

                return day;
            });

            return range;
        });

        return item;
    });
}

export function LoadHotelsForVariations() {
    return async function(dispatch, getState) {
        dispatch({
            type: 'HOTELS/LOAD',
        });

        const {cart, packages} = getState();
        const productId = cart.product.id;
        const confirmedShowId = packages.confirmed_package.id;

        const response = await fetch(
            `${application.titan_url}/api/events/${productId}/show/${confirmedShowId}/hotels?guests=${cart.confirmed_tickets.length}`,
            {
                headers: {
                    'Accept': 'application/json',
                },
            },
        );

        const data = await response.json();
        const items = parseHotelItems(data);

        dispatch({
            type: 'HOTELS/LOAD_FINISHED',
            payload: {
                items: items,
            },
        });
    };
}

export function SelectNoHotel() {
    return function(dispatch) {
        dispatch({
            type: 'HOTELS/NOHOTEL',
        });
    };
}

export function SelectHotel(hotel) {
    return function(dispatch) {
        dispatch({
            type: 'HOTELS/SELECT',
            payload: hotel,
        });
    };
}

export function DeselectHotel() {
    return function(dispatch) {
        dispatch({
            type: 'HOTELS/DESELECT',
        });
    };
}

export function ReloadHotels() {
    return function(dispatch) {
        dispatch({
            type: 'HOTELS/DESELECT',
        });

        dispatch(LoadHotelsForVariations());
    };
}

export function SelectHotelNights(value) {
    return function(dispatch) {
        dispatch({
            type: 'HOTELS/SELECT_NIGHTS',
            payload: value,
        });
    };
}

export function SelectHotelRange(value) {
    return function(dispatch) {
        dispatch({
            type: 'HOTELS/SELECT_RANGE',
            payload: value,
        });
    };
}

export function SelectHotelRoomType(value) {
    return function(dispatch) {
        dispatch({
            type: 'HOTELS/SELECT_ROOM_TYPE',
            payload: value,
        });
    };
}

export function ConfirmHotel() {
    return function(dispatch, getState) {
        let {hotels} = getState();

        dispatch({
            type: 'HOTELS/CONFIRM',
            payload: {
                confirmed_hotel: hotels.selected_hotel,
                confirmed_hotel_range: hotels.selected_hotel.ranges[hotels.selected_hotel_nights][hotels.selected_hotel_range],
                selected_hotel_range: hotels.selected_hotel_range,
                selected_hotel_nights: hotels.selected_hotel_nights,
                selected_hotel_roomtype: hotels.selected_hotel_roomtype,
            },
        });
    };
}
